const subscriptionInvoicesKeys = {
  // Section Headers
  "subscription.invoices.title": "Facturas",

  // Table Headers
  "subscription.invoices.column.date": "Fecha",
  "subscription.invoices.column.description": "Descripción",
  "subscription.invoices.column.amount": "Monto",
  "subscription.invoices.column.status": "Estado",
  "subscription.invoices.column.receipt": "Recibo",

  // Invoice Descriptions
  "subscription.invoices.description.other": "Otro",
  "subscription.invoices.description.new": "Nueva suscripción {{interval}}: {{quantity}} plazas",
  "subscription.invoices.description.update": "Suscripción {{previousInterval}} actualizada a {{interval}}: {{quantity}} plazas {{action}}",
  "subscription.invoices.description.update.simple": "Actualización de suscripción: {{quantity}} plazas {{action}}",
  "subscription.invoices.description.cycle": "Pago {{interval}}: {{quantity}} plazas",

  // Interval Types - Using direct API values
  "subscription.invoices.interval.month": "Mensual",
  "subscription.invoices.interval.year": "Anual",

  // Actions
  "subscription.invoices.action.added": "añadidas",
  "subscription.invoices.action.removed": "eliminadas",

  // Receipt
  "subscription.invoices.receipt.pdf": "PDF",
  "subscription.invoices.receipt.na": "N/D",
};

export const subscriptionInvoices = {
  ...subscriptionInvoicesKeys,
};
